export const STORAGE_KEY_INCOMING_FEED_URL = 'rp-embedFeedUrl';
